<template>
    <div class="import-page-wrap">
        <div class="back-wrap">
            <span class="back-icon" @click="handleBack"><i class="el-icon-arrow-left"></i>返回</span>
            <span class="back-title">导入产品</span>
        </div>
        <div class="import-page-main flex">
            <div class="import-page-aside">
                <ul>
                    <li class="flex" v-for="(item, index) in stepList" :key="index">
                        <i class="step-icon"></i>
                        <div>
                            <p class="list-title">{{ item.title }}</p>
                            <p v-for="(sepcItem, sepcIndex) in item.content" :key="sepcIndex">{{ sepcItem }}</p>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="import-page-content">
                <!--导入模版-->
                <template v-if="importstate == 0 || importstate == 1">
                     <div class="download-tip">
                         <i class="iconfont icon-tishi"></i>
                         <span>下载【标准模版】</span>
                         <el-button @click="handleClickDownloadTemplate">下载模版</el-button>
                     </div>

                     <div class="download-wrap"
                          v-loading="loading"
                          element-loading-text="文件导入中  请稍等..."
                          element-loading-spinner="el-icon-loading"
                          element-loading-background="rgba(0, 0, 0, 0.8)">
                        <!--导入模版-->
                         <template v-if="importstate == 0">
                             <input class="upload_input" accept=".xls,.xlsx"  type="file"  @change="handleUploadFileChange($event)">
                             <img class="download-icon" src="https://download.hecoos.com/enlightv/2024-42/e22ea4a203115fcf34f7057ed61dc242.png" alt="">
                             <p>将文件拖拽至此，也可以<el-button type="text">【点击上传】</el-button></p>
                         </template>

                        <!-- 正在导入中-->
                         <template v-if="importstate == 1">
                             <img v-if="import_percentage == 100" class="download-icon" src="https://download.hecoos.com/enlightv/2024-42/145324bb3de7bade655b3543df7510a3.png"   alt="">
                             <img v-else class="download-icon" src="https://download.hecoos.com/enlightv/2024-42/e22ea4a203115fcf34f7057ed61dc242.png" alt="">
                            {{import_percentage}}
                             <div class="import_wrap_percentage">
                                 <el-progress :percentage="import_percentage" :key="progressKey" :stroke-width="14" :text-inside="true"></el-progress>
                             </div>
                             <div class="upload-text" v-text="import_percentage == 100 ? '文件导入完成' : '文件导入中  请稍等...'"></div>
                         </template>
                     </div>
                </template>

                <!--获取导入模版中的数据-->
                <template v-if="importstate == 2">
                    <div class="download-tip download-tip-warn">
                        <i class="icon-jinggao iconfont"></i>
                        <span>请注意查看数据是否正确</span>
                    </div>
                    <div class="table-wrap">
                        <el-table class="custom_table" :data="errorData" border  ref="table" height="calc(100vh - 280px)" >
                            <el-table-column label="产品名称" prop="name" show-overflow-tooltip  class-name=" tableInputColumn"	 min-width="140px">
                                <template #header>
                                    <span style="margin-right: 4px">产品名称</span>
                                    <el-tooltip class="item" effect="dark" content="导入中英文及汉字不做限制，特殊符号、空格不做限制" placement="top">
                                        <span class="handle_icon_wrap">
                                            <i class="iconfont icon-yiwen"></i>
                                        </span>
                                    </el-tooltip>
                                </template>
                                <template slot-scope="{row,$index}">
                                    <el-input class="error_name" :class="row.repeat_name ? 'repeat_name' : row.error_name ?  'error_name' : ''" v-model="row.name" @change="handleChangeName(row,$index)" placeholder="请输入产品名称"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="产品单价" prop="cost_price" min-width="140px"  class-name="tableInputColumn">
                                <template #header>
                                    <span style="margin-right: 4px">产品单价</span>
                                </template>
                                <template slot-scope="{row}">
                                    <el-input-number v-if="row.error_cost_price"  class="el-input-number-left error_name" :precision="2" v-model="row.cost_price" :min="0" @change="handleChangeCostPrice(row)" :controls="false" placeholder="请输入产品单价"></el-input-number>
                                    <span v-else v-text="row.cost_price"></span>
                                </template>
                            </el-table-column>
                            <el-table-column label="单位" prop="unit" show-overflow-tooltip  min-width="140px" class-name="tableInputColumn"></el-table-column>
                            <el-table-column label="所选仓库" prop="stock_name" show-overflow-tooltip  min-width="140px" class-name="tableInputColumn"></el-table-column>
                            <el-table-column label="库存数量" prop="no_code_num" min-width="140px"  class-name="tableInputColumn">
                                <template #header>
                                    <span style="margin-right: 4px">库存数量</span>
                                    <el-tooltip class="item" effect="dark" content="只可输入正整数，不可输入汉字或英文或特殊符号" placement="top">
                                        <span class="handle_icon_wrap">
                                            <i class="iconfont icon-yiwen"></i>
                                        </span>
                                    </el-tooltip>
                                </template>
                                <template slot-scope="{row}">
                                    <el-input-number v-if="row.error_num"  class="el-input-number-left error_name"  v-model="row.no_code_num" :min="1" @change="handleChangeNum(row)" :controls="false" placeholder="请输入库存数量"></el-input-number>
                                    <span v-else v-text="row.no_code_num"></span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="table-footer-btn">
                        <el-button type="primary" @click="handleClickAgain()" plain>重新导入</el-button>
                        <el-button type="primary" @click="handleSubmitData">上传数据</el-button>
                    </div>
                </template>

                <!--上传数据-导入成功-->
                <template v-if="importstate == 3">
                   <div class="download-tip download-tip-success" >
                       <i class="el-icon-success iconfont"></i>
                       <span>导入成功</span>
                   </div>
                    <div class="download-wrap">
                       <img class="download-icon" src="https://download.hecoos.com/enlightv/2024-42/145324bb3de7bade655b3543df7510a3.png" alt="">
                       <div class="import_wrap_percentage">
                           <el-progress :percentage="uploadStatus.progress > 100 ?  100 : uploadStatus.progress" :stroke-width="14" :text-inside="true"></el-progress>
                       </div>
                        <div class="upload-text">导入成功</div>
<!--                       <div class="upload-text">已导入20条数据，其中18条为新增产品，2条重复产品数据，重复产品信息已覆盖更新</div>-->
                    </div>
                    <el-button type="primary" class="custom-primary-btn" :disabled="uploadStatus.progress < 100 ? true : false" @click="handleClickSave">确定</el-button>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import {stockImport } from "@/api/index.js"
import {uploadImg,getOSSData} from '@/utils/uploadOss'
import XLSX from 'xlsx';
export default {
    name: "WarehouseImport",
    components: {},
    data() {
        return {
            loading:false,
            stepList: [
                { title: "上传文件", content: ['通过Excel文件导入产品数据'] },
                { title: "匹配列表数据", content: ["将表格中的表头", "及格式与系统内的字段关联"] },
                { title: "导入数据", content: ["将文件中的产品数据导入系统"] }
            ],
            importstate: 0, //== 0 还没导入，== 1导入中， == 2 展示导入的数据 , ==3确定导入数据
            import_percentage: 0,
            import_msg: '',
            xlsxJsonData: [],
            errorData:[],
            successData:[],

            productData: [],
            uploadStatus: {
                progress: 0,          // 总进度百分比
                succeedBatches: 0,    // 成功批次数量
                currentBatch: 0,      // 当前处理中批次
                totalSize: 0,         // 总字节数（用于进度计算）
                uploadedSize: 0       // 已上传字节数
            },
            batchSize: 500,         // 每批数据量
            maxRetries: 3,          // 单批次最大重试次数
            progressKey:0
        }
    },
    computed: {
        // 计算总批次数
        totalBatches() {
            return Math.ceil(this.productData.length / this.batchSize);
        },
        // 生成所有分块数组
        batchedData() {
            const batches = [];
            for (let i = 0; i < this.productData.length; i += this.batchSize) {
                batches.push(this.productData.slice(i, i + this.batchSize));
            }
            return batches;
        }
    },
    methods: {
        // 下载模版
        handleClickDownloadTemplate(){
            getOSSData('https://download.hecoos.com/enlightv/2025-11/db2bfd5c1814503eda34c6397cd1ab58.xlsx', '仓库管理导入模板.xlsx');
        },
        handleBack() {
            this.$router.back()
        },
        // 上传附件
        handleUploadFileChange(event){
            // this.importstate = 1;
            this.loading = true
            const file = event.target.files[0]
            if (!file) return;
            // 重置数据
            this.xlsxJsonData = [];
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onprogress = (e) => {
                if (e.lengthComputable) {
                    const percent = Math.round((e.loaded / e.total) * 100);
                    this.$set(this,'import_percentage',percent)
                    this.$forceUpdate()
                }
            };
            reader.onload = (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    // 获取第一个工作表
                    const worksheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[worksheetName];

                    // 获取原始二维数组数据
                    const rawData = XLSX.utils.sheet_to_json(
                            worksheet,
                            { header: 1, defval: '' , blankrows: false } // 保证空单元格处理  // 关闭默认空行保留
                    );
                    if (rawData.length === 0) return;
                    // 设置表头
                    let headersData = rawData[1];
                    // 处理数据行并严格对齐表头顺序
                    let xlsxJsonData = rawData.slice(2).map(row => {
                        return headersData.map((_, index) => {
                            // 根据索引获取单元格值，缺失则返回空字符串
                            return row[index] !== undefined ? row[index] : '';
                        });
                    });
                    this.xlsxJsonData = xlsxJsonData.map(item => ({
                        name: item[headersData.findIndex(find => find.includes('产品名称'))] ? item[headersData.findIndex(find => find.includes('产品名称'))] : '',
                        cost_price: item[headersData.findIndex(find => find.includes('产品单价'))] ? item[headersData.findIndex(find => find.includes('产品单价'))] : 0,
                        unit: item[headersData.findIndex(find => find.includes('单位'))] ? item[headersData.findIndex(find => find.includes('单位'))] : '',
                        stock_name: item[headersData.findIndex(find => find.includes('所属仓库'))] ? item[headersData.findIndex(find => find.includes('所属仓库'))] : '示例仓库',
                        code_num:0,
                        no_code_num: item[headersData.findIndex(find => find.includes('库存数量'))] ? item[headersData.findIndex(find => find.includes('库存数量'))] : '',
                        total_num: item[headersData.findIndex(find => find.includes('库存数量'))] ? item[headersData.findIndex(find => find.includes('库存数量'))] : '',

                    }));
                    this.loading = false
                    this.checkJsonData()
                    if(this.errorData.length>0){
                        this.importstate = 2
                    }else{
                        this.handleSubmitData()
                    }

                } catch (error) {

                }
            };
            reader.onerror = () => {
                this.loading = false
                this.$message.error("文件读取失败");
            };
            event.target.value = ''
        },
        // 校验 - 获取正确数据和错误数据
        checkJsonData(){
            let errorData = []
            let successData = []
            this.xlsxJsonData.forEach((item,key) => {
                const regex = /^[1-9]\d*$/; // 正整数的正则表达式
                const regex_price = /^(0|[1-9]\d*)(\.\d{1,2})?$/;  //金额正则
                if (!regex.test(item.no_code_num) || !item.name || this.xlsxJsonData.find((findItem,findIndex) => (findItem.name === item.name && key !== findIndex))) {
                    if(!regex.test(item.no_code_num)){
                        this.$set(item,'no_code_num',undefined)
                        this.$set(item,'error_num',true)
                    }
                    if(!regex_price.test(item.cost_price)){
                        this.$set(item,'cost_price',undefined)
                        this.$set(item,'error_cost_price',true)
                    }
                    if(!item.name){
                        this.$set(item,'error_name',true)
                    }
                    if(this.xlsxJsonData.find((findItem,findIndex) => (findItem.name === item.name && key !== findIndex && item.name !=''))){
                        this.$set(item,'repeat_name',true)
                    }
                    errorData.push(item)
                }else{
                    successData.push(item)
                }
            })

            this.successData = successData
            this.errorData = errorData
        },
        // 修改名称
        handleChangeName(row,index){
            this.errorData.forEach((item,key)=>{
                this.$set(item,'error_name',false)
                this.$set(item,'repeat_name',false)
                if(!item.name){
                    this.$set(item,'error_name',true)
                }
                if(this.errorData.find((findItem,findIndex) => (findItem.name == item.name && key != findIndex  && item.name !=''))){
                    this.$set(item,'repeat_name',true)
                }
            })
        },
        // 修改数量
        handleChangeNum(row){
            const regex = /^[1-9]\d*$/; // 正整数的正则表达式
            this.$nextTick(()=>{
                if(!regex.test(row.no_code_num)){
                    this.$set(row,'no_code_num',undefined)
                    console.log(regex.test(row.no_code_num));
                }
                this.$set(row,'total_num',row.no_code_num)
            })
        },
        handleChangeCostPrice(row){
            const regex_price = /^(0|[1-9]\d*)(\.\d{1,2})?$/;  //金额正则
            this.$nextTick(()=>{
                if(!regex_price.test(row.cost_price)){
                    this.$set(row,'cost_price',0)
                }
            })
        },
        // 重新导入
        handleClickAgain(){
            this.importstate = 0
            this.productData = []
            this.uploadStatus =  JSON.parse(JSON.stringify(this.$options.data().uploadStatus))
            this.import_msg = ''
            this.xlsxJsonData = []
            this.errorData = []
            this.successData = []
        },
        // 上传数据
        handleSubmitData(){
            const regex_price = /^(0|[1-9]\d*)(\.\d{1,2})?$/;
            const regex = /^[1-9]\d*$/;
            if(this.errorData.filter(item=> item.repeat_name || item.error_name || !regex.test(item.no_code_num) || !regex_price.test(item.cost_price)).length){
                this.$message.error('请注意查看数据是否正确')
                return false
            }

            this.errorData.forEach(item=>{
                delete  item.repeat_name
                delete  item.error_name
                delete  item.error_num
                delete  item.error_cost_price
            })
            this.productData =  [...this.errorData,...this.successData]

            this.importstate = 3

            this.startBatchUpload()
        },

        async startBatchUpload() {
            // 初始化状态
            this.uploadStatus = {
                progress: 0,
                succeedBatches: 0,
                currentBatch: 0,
                totalSize: this.calculateTotalSize(),
                uploadedSize: 0
            };

            // 逐批上传
            for (let i = 0; i < this.batchedData.length; i++) {
                let retries = 0;
                while (retries < this.maxRetries) {
                    try {
                        await this.uploadSingleBatch(i);
                        retries = this.maxRetries; // 退出重试循环
                    } catch (error) {
                        retries++;
                        if (retries >= this.maxRetries) {
                            let batch = this.batchSize * (i+1)
                            // 第 ${i + 1} 批次
                            this.$confirm(`前${batch}条数据上传成功，后面的数据上传失败，停止上传`, '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => { }).catch(() => {});
                            return;
                        }
                    }
                }
            }

            this.$message.success('全部批次上传完成');


        },

        // 上传单个批次
        uploadSingleBatch(batchIndex) {
            return new Promise((resolve, reject) => {
                // 获取当前批次数据
                const batch = this.batchedData[batchIndex];
                const batchSize = JSON.stringify(batch).length; // 计算当前批次字节数
                stockImport({ batch: batch },
                        (progressEvent) => {
                            if (progressEvent.lengthComputable) {
                                // 更新进度 = 已上传批次字节总和 + 当前批次上传字节
                                const loaded = this.uploadStatus.uploadedSize + progressEvent.loaded;
                                this.uploadStatus.progress = Math.round(
                                        (loaded / this.uploadStatus.totalSize) * 100
                                );
                            }}
                       ).then(res => {
                            this.uploadStatus.succeedBatches++;
                            this.uploadStatus.uploadedSize += batchSize; // 当前批次完整计入
                            resolve();
                        }).catch(error => {
                            reject(error);
                        });
            });
        },

        // 计算总数据体积（优化进度准确度）
        calculateTotalSize() {
            return JSON.stringify(this.productData).length;
        },

        // 确定数据
        handleClickSave(){
            this.$router.go(-1);
        }
    }
}
</script>
<style lang="scss" scoped>
.import-page-wrap {
    height: 100%;

    .back-wrap {
        padding: 12px 0 12px 18px;
        border-bottom: 1px solid rgba(232, 232, 232, 1);
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 24px;
        color: rgba(102, 102, 102, 1);
        display: flex;
        align-items: center;

        .back-icon {
            border-radius: 4px;
            cursor: pointer;

            &:hover {
                background-color: rgba(0, 0, 0, 0.04);
                color: rgba(51, 51, 51, 1);
            }
        }

        .back-title {
            font-weight: 700;
            color: rgba(51, 51, 51, 1);
            padding-left: 17px;
            position: relative;

            &::before {
                content: "";
                position: absolute;
                left: 8px;
                top: 4px;
                width: 1px;
                height: 16px;
                background: rgba(232, 232, 232, 1);
            }
        }

    }

    .import-page-main {
        height: calc(100% - 49px);

        .import-page-aside {
            width: 246px;
            background: rgba(0, 0, 0, 0.04);
            padding: 114px 30px 0;

            ul {
                position: relative;

                &::before {
                    content: "";
                    display: block;
                    position: absolute;
                    left: 8px;
                    top: 11px;
                    width: 1px;
                    height: 178px;
                    background: rgba(217, 217, 217, 1);
                }
            }

            li {
                margin-bottom: 36px;

                .step-icon {
                    display: block;
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    background: rgba(25, 144, 255, 1);
                    position: relative;
                    margin-right: 12px;
                    margin-top: 3px;
                    flex-shrink: 0;

                    &::before {
                        content: "";
                        position: absolute;
                        top: 4px;
                        left: 4px;
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                        background: rgba(255, 255, 255, 1);

                    }
                }

                p {
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(102, 102, 102, 1);
                }

                .list-title {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                    margin-bottom: 4px;
                }
            }
        }
    }

    .import-page-content {
        padding: 24px 24px 0 26px;
        flex: 1;
        position: relative;
    }

    .download-tip {
        width: 100%;
        height: 54px;
        border-radius: 8px;
        background: rgba(203, 225, 245, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(25, 144, 255, 1);

        &>.iconfont {
            margin-right: 8px;
        }

        .el-button {
            margin-left: 8px;
            padding: 0;
            width: 88px;
            height: 32px;
            opacity: 1;
            border-radius: 52px;
            background: rgba(255, 255, 255, 1);

            border: 1px solid rgba(25, 144, 255, 1);
            text-align: center;
            line-height: 32px;
            color: rgba(25, 144, 255, 1);
            font-weight: 400;
        }

        &.download-tip-warn {
            background-color: rgba(252, 238, 214, 1);
            color: rgba(240, 170, 50, 1);

            .icon-jinggao {
                color: rgba(240, 170, 50, 1);

            }
        }
        &.download-tip-success {
            background: rgba(222, 240, 214, 1);
            color: rgba(90, 179, 51, 1);
            i {
                color: rgba(90, 179, 51, 1);
                font-size: 16px;
            }
        }
    }

    .download-wrap {
        margin-top: 36px;
        width: 100%;
        height: calc(100vh - 300px);
        border-radius: 8px;
        background: rgba(247, 248, 250, 1);
        border: 2px dashed rgba(217, 217, 217, 1);
        box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03);
        padding-top: 200px;
        text-align: center;
        position: relative;
        .upload_input{
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 1;
            left: 0;
            top: 0;
            opacity: 0;
            cursor: pointer;
        }
        input[type="file"]::-webkit-file-upload-button{cursor: pointer;}
        .download-icon {
            width: 140px;
        }

        .import_wrap_percentage {
            width: 69.1%;
            margin: 16px auto;
        }

        .upload-text {
            font-size: 18px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 28px;
            color: rgba(51, 51, 51, 1);
            text-align: center;
        }
    }



    .table-wrap {
        margin-top: 24px;
    }

    .error_name{
        ::v-deep .el-input__inner{
            /* 通用浏览器兼容写法 */
            &::-webkit-input-placeholder { /* Chrome/Safari/新版Edge */
                color: rgba(228, 65, 68, 1);
            }
            &:-moz-placeholder { /* Firefox 18- */
                color:rgba(228, 65, 68, 1);
                opacity: 1; /* Firefox 默认降低透明度，需重置 */
            }
            &::-moz-placeholder { /* Firefox 19+ */
                color:rgba(228, 65, 68, 1);
                opacity: 1;
            }
            &:-ms-input-placeholder { /* IE 10-11 */
                color:rgba(228, 65, 68, 1);
            }
            &::placeholder { /* 现代浏览器标准写法 */
                color: rgba(228, 65, 68, 1);
            }
        }
    }

    .repeat_name{
        ::v-deep .el-input__inner{
            color: rgba(240, 170, 50, 1);
        }
    }

    .txt-danger {
        color: rgba(228, 65, 68, 1);
    }

    .txt-warn {
        color: rgba(240, 170, 50, 1);
    }

    .table-footer-btn {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 10px 24px;
        text-align: center;
        border-radius: 0px 0px, 8px, 8px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px -2px 4px -2px rgba(0, 0, 0, 0.08);

        .el-button {
            font-weight: 400;
            padding: 4px 15px;
            line-height: 22px;

            &.el-button--primary.is-plain {
                border-color: rgba(41, 144, 255, 1);
                background-color: transparent;
                color: rgba(41, 144, 255, 1);
            }
        }
    }
}
.custom-primary-btn {
    width: 126px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    text-align: center;
    line-height: 32px;
    padding: 0;
    margin-top: 36px;
    margin-left: 50%;
    transform: translateX(-50%);

}
</style>
<style lang="scss">
.custom-tooltip-confirm-dialog {
    .el-button {
        position: relative;
    }
}
</style>
